import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-front-hook-form',
  templateUrl: './front-hook-form.component.html',
  styleUrls: ['./front-hook-form.component.scss']
})
export class FrontHookFormComponent implements OnInit {

  public data: any = {}
  constructor(
    private http: HttpService, 
    private activatedRoute: ActivatedRoute
  ) { 
    this.activatedRoute.params.subscribe(params => {
      this.init(params['banner_uuid']);
    });
  }

  ngOnInit(): void {
  }

  async init(banner_uuid = null) {
    // this.data = await this.http.post('/admin/app/hook', {banner_uuid});
  }

  async submit() {
    // const s = await this.http.post("/admin/app/hook/update", this.data)

    // if (s['status']) {
    //   this.http.notify("Hook update successfully.")
    //   this.http.naviBack();
    // }
  }

  async loadFile(fileInput: any, name: string) {
    // this.data[name] = await this.http.fileChangeEvent(fileInput);
  }

}
